import * as React from "react";
import { useState } from "react";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Form,  Button, message } from "antd";
import { Puff } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import userServiceInstance from "../../APIs/users";
import TextInput from "../ReusableInputs/TextInput";
import { useNotification } from "../Toast/Notification";
const Loader: React.FC = () => {
  return (
    <div className="flex items-center justify-center ">
      <Puff
        visible={true}
        height="60"
        width="60"
        color="#75A7AD"
        ariaLabel="puff-loading"
      />
    </div>
  );
};

const RequestPasswordReset = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { notify } = useNotification();

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const { success, } = await userServiceInstance.requestPasswordReset(email);
  
      if (success) {
        notify("Email sent successfully. Please check your inbox.", "success");
        navigate("/email-sent");
      } else {
        notify("Email address not found. Please check and try again.", "error");
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      message.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header
        title="RESET PASSWORD"
        desktopHeight="auto"
        textBackground="RESET PASSWORD"
        backgroundImg="http://res.cloudinary.com/brabenjos/image/upload/v1729584914/sodastream/1729584914532.png"
        subTitle=""
      />
    <section className="relative w-full mt-[-35%] z-50 mb-[0px] lg:mb-[140px] p-4">

        <div className="md:relative gap-10 z-50 flex flex-col items-center justify-center w-full">
          <div className="bg-white rounded-xl border-[0.5px] border-[#75A7AD] relative sm:w-[50%] opacity-80 px-10 py-20 text-[#005D6E]">
            <div className="bg-white">
              <div className="w-full">
                <Form
                  name="reset_password_form"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  className="signin-form"
                  form={form}>
                  <section className="md:flex-row md:space-x-4">
                    <div className="w-full p-2">
                      
                        <TextInput
                          title="Email Address"
                          // prefix={<UserOutlined className="site-form-item-icon" />}
                          placeholder="Enter your email address"
                          inputValue={email}
                          setInputValue={setEmail}
                          name="email"
                      rules={[
                        {
                          required: true,
                          message: "Please input your email",
                        },
                        {
                          type: "email",
                          message: "Please enter a valid email address",
                        },
                      ]}
                        />
                     
                    </div>
                  </section>

                  <section className="flex flex-col md:flex-row md:space-x-4">
                    <div className="w-full">
                      <Form.Item className="text-center">
                        {loading ? (
                          <Loader />
                        ) : (
                          <Button
                            htmlType="submit"
                            className="custom-button w-full  border border-[#75A7AD] 
                        h-[45px] text-[16px] text-white font-bold rounded-full bg-[#75A7AD] 
                        flex items-center justify-center">
                            Reset Password
                          </Button>
                        )}
                      </Form.Item>
                    </div>
                  </section>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default RequestPasswordReset;
